export const saveVendorDetails = (payload, isSubmit) => ({
  type: 'SAVE_VENDOR_DETAILS',
  loader: true,
  payload,
  isSubmit,
});
export const saveInvoiceDetails = (payload, isSubmit) => ({
  type: 'SAVE_INVOICE_DETAILS',
  loader: true,
  payload,
  isSubmit,
});

export const getInvoiceDetails = payload => ({
  type: 'GET_INVOICE_DETAILS',
  payload,
  loader: true,
});

export const getVendorDetails = payload => ({
  type: 'EDIT_VENDOR_DETAILS',
  payload,
  loader: true,
});

export const setInvoicePromptError = () => ({
  type: 'SET_INVOICE_PROMPT_ERROR',
});

export const setInvoiceDetails = (data, promptError) => ({
  type: 'SET_INVOICE_DETAILS',
  data,
  loader: false,
  promptError,
});
export const setVendorDetails = data => ({
  type: 'SET_VENDOR_DETAILS',
  data,
  loader: false,
});
export const getVendorList = () => ({
  type: 'GET_VENDOR_LIST',
});

export const setVendorList = data => ({
  type: 'SET_VENDOR_LIST',
  data,
});
export const getCurrencyList = () => ({
  type: 'GET_CURRENCY_LIST',
});

export const setCurrencyList = data => ({
  type: 'SET_CURRENCY_LIST',
  data,
});
export const getCityState = data => ({
  type: 'GET_CITY_STATE',
  data,
  // loader: true,
});
export const setCityState = data => ({
  type: 'SET_CITY_STATE',
  data,
});
export const getGstinDetails = payload => ({
  type: 'GET_GSTIN_DETAILS',
  payload,
});

export const setGstinDetails = (data, gstFetchedFailed) => ({
  type: 'SET_GSTIN_DETAILS',
  data,
  gstFetchedFailed,
});

export const getWorkFlowDetails = payload => ({
  type: 'GET_WORKFLOW',
  payload,
  loader: true,
});
export const getWorkVendorFlowDetails = payload => ({
  type: 'GET_VENDOR_WORKFLOW',
  payload,
});

export const workflowContainerAction = (
  payload,
  commentData,
  scheduleDateParam,
) => ({
  type: 'WORKFLOW_CONTAINER_ACTION',
  payload,
  loader: true,
  commentData,
  scheduleDateParam,
});
export const workflowVendorContainerAction = payload => ({
  type: 'WORKFLOW_VENDOR_CONTAINER_ACTION',
  payload,
});
export const workflowVendorContainerCommentAction = (
  containerData,
  commentData,
) => ({
  type: 'WORKFLOW_VENDOR_CONTAINER_COMMENT_ACTION',
  loader: true,
  containerData,
  commentData,
});

export const updateInvoiceDetails = (payload, isSubmit) => ({
  type: 'UPDATE_INVOICE',
  payload,
  isSubmit,
  loader: true,
});

export const updateVendorDetails = (payload, isSubmit) => ({
  type: 'UPDATE_VENDOR',
  payload,
  isSubmit,
  loader: true,
});
export const generateOTP = payload => ({
  type: 'GENERATE_INVOICE_OTP',
  payload,
});
export const submitInvoice = payload => ({
  type: 'SUBMIT_INVOICE',
  payload,
  loader: true,
});
export const submitVendor = payload => ({
  type: 'SUBMIT_VENDOR',
  payload,
  loader: true,
});
export const invoiceSubmitConfirmationAction = data => ({
  type: 'INVOICE_SUBMIT_CONFIRMATION',
  data,
  loader: false,
});

export const getWorkflowComments = payload => ({
  type: 'GET_WORKFLOW_COMMENT',
  payload,
});
export const setWorkflowComments = data => ({
  type: 'SET_WORKFLOW_COMMENT',
  data,
});
export const getBankDetailsThroughIfsc = payload => ({
  type: 'GET_IFSC_BANK_DETAILS',
  payload,
});
export const setBankDetailsThroughIfsc = payload => ({
  type: 'SET_IFSC_BANK_DETAILS',
  payload,
});
export const getChequeDetails = (payload, shimmerCallBack) => ({
  type: 'GET_CHEQUE_DETAILS',
  payload,
  shimmerCallBack,
});
export const setChequeDetails = payload => ({
  type: 'SET_CHEQUE_DETAILS',
  payload,
});

export const updateFiles = (files, deletedFileIndex) => ({
  type: 'UPDATE_FILES',
  files,
  deletedFileIndex
});
export const getData = (s3Payload, ocrPayload, deletedFileIndex) => ({
  type: 'GET_DATA',
  s3Payload,
  ocrPayload,
  deletedFileIndex,
});
export const setData = (
  s3Data = {},
  ocrData = {},
  deletedFileIndex,
  ocrError = "",
) => ({
  type: 'SET_DATA',
  s3Data,
  ocrData,
  deletedFileIndex,
  ocrError
});

export const invoiceBulkAction = payload => ({
  type: 'INVOICE_BULK_ACTION',
  payload,
  loader: true
});

export const invoiceBulkActionSuccess = (data) => ({
  type: 'INVOICE_BULK_SUCCESS',
  data,
  loader: false
});
export const rescheduleInvoice = payload => ({
  type: 'RESCHEDULE_PAYMENT',
  payload,
  loader: true,
});

export const rescheduleCancelSuccess = (type, value) => ({
  type: 'RESCHEDULE_CANCEL_SUCCESS',
  successType: type,
  loader: false,
  value,
});

export const cancelPayment = payload => ({
  type: 'CANCEL_PAYMENT',
  payload,
  loader: true,
});
